import React from 'react'
import Frame from './layout/Frame'
import Upload from './layout/Upload'
import SigningComplete from './layout/SigningComplete'
import Admin from './layout/Admin'
import Document from './layout/Document'
import Fill from './layout/Fill'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import PrivateRoute from './util/PrivateRoute'
import '../sass/styles.scss'
import { useAuth } from '../authContext'
import PageLoader from './util/PageLoader'
import ErrorPage from './layout/ErrorPage'
import queryString from 'query-string'

const App = () => {
  const { loading } = useAuth()

  if (loading) return <PageLoader />

  const parsed = queryString.parse(window.location.search)

  if (parsed && ['unauthorized', 'access_denied'].includes(parsed.error))
    return <ErrorPage parsed={parsed} />

  if (parsed && parsed.status === 'signing-complete')
    return <SigningComplete success={true} requestId={parsed.requestId} />
  else if (parsed && parsed.status === 'signing-cancelled')
    return <SigningComplete success={false} />
  else if (parsed && parsed.status === 'signing-expired')
    return <SigningComplete expired />

  return (
    <BrowserRouter>
      <Frame>
        <Switch>
          <Route path="/fill/:hash" component={Fill} />
          <PrivateRoute exact path="/" component={Upload} />
          <PrivateRoute path="/admin" component={Admin} />
          <PrivateRoute path="/doc/:hash" component={Document} />
        </Switch>
      </Frame>
    </BrowserRouter>
  )
}

export default App
